<template>
  <div class="flex flex-c">
    <div class="articlebox">
      <h3 class="text titlebox">{{ artinfo.title }}</h3>
      <p class="text newsInfo">发表时间：{{ artinfo.createTime }}</p>
      <div>
        <img :src="artinfo.cover" alt="" />
      </div>
      <p class="text contentbox">{{ artinfo.content }}</p>
      <div class="flex">
        <div v-for="(item, index) in detailimg" :key="index" class="detailurl">
          <el-image class="goodsimg" :src="item" :preview-src-list="[item]" />
        </div>
      </div>
      <div class="flex bottombox">
        <div class="nextNotesTitle">
          <p class="text" v-if="artinfo.lastNotesTitle" @click="next(artinfo.lastNotesId)">
            上一篇 {{ artinfo.lastNotesTitle }}
          </p>
          <p class="text" v-if="artinfo.nextNotesTitle"  @click="next(artinfo.nextNotesId)">
            下一篇 {{ artinfo.nextNotesTitle }}
          </p>
        </div>
        <div class="share">
          <span>分享到：</span>
          <a @click="jumptoweixin" class="shareIcon Weixin"></a>
          <a @click="jumptoweibo" class="shareIcon sina_weibo"></a>
          <a @click="jumptoqq" class="shareIcon qq_share"></a>
          <!-- <a @click="jumptoqq_zone" class="shareIcon qq_zone"></a> -->
          <!-- <a  @click="jumptodouban"  class="shareIcon douban"></a> -->
          <a @click="jumptobaidu_tieba" class="shareIcon baidu_tieba"></a>
        </div>
      </div>
    </div>
    <el-backtop :right="100" :bottom="100" />
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { notesDetailApi } from "@/api/index.js";

const { proxy } = getCurrentInstance();
const store = useStore();
const route = useRoute();
const router = useRouter();
let artinfo = ref({});
let detailimg = ref([]);
onMounted(() => {
  let id = route.query.id;
  getList(id);
});
// 上一篇
const next = (val)=>{
     window.open(
    `https://www.laolesiyun.com/article?id=${val}`,
    "_blank"
  );
}
const getList = (id) => {
  notesDetailApi({ id })
    .then((res) => {
      artinfo.value = res;
      detailimg.value = res.image.split(",");
    })
    .catch((err) => {
      console.log(err);
    });
};
// 转发至微信
const jumptoweixin = () => {
 localStorage.setItem("shareUrl", this.shareUrl); // 存储当前页面地址，前端页面直接根据URL链接生成二维码
      let url = location.href.split("#")[0] + "#/Share/toWechat"; // 注意：#/Share/toWechat: 自己定义的路由
      window.open(url);
};
// 转发至微博
const jumptoweibo = () => {
  window.open(
    `http://service.weibo.com/share/share.php?title=${encodeURIComponent(artinfo.value.title)}`,
    "_blank"
  );
};
// 转发至qq
const jumptoqq = () => {
  window.open(
    `http://connect.qq.com/widget/shareqq/index.html`,
    "_blank"
  );
};
// 转发至qq空间
const jumptoqq_zone = () => {
window.open(
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
          encodeURIComponent(artinfo.value.createTime) +
          "&title=" +
          888 +
          "&summary=" +
          artinfo.value.createTime
      );
};
// 转发至豆瓣
const jumptodouban = () => {
  window.open(`http://shuo.douban.com`, "_blank");
};
// 转发至贴吧
const jumptobaidu_tieba = () => {
let url = 'https://web.galaku.cn/nd.jsp?id=8'
  window.open(
    `http://tieba.baidu.com/i/app/open_share_api?comment=&title=${artinfo.value.title}&url=${url}`,
    "_blank"
  );
};
</script>
<style scoped lang='scss'>
.articlebox {
  width: 60%;
  margin: 50px 0;
}
::v-deep .demo-image__error .el-image {
  width: 100%;
  height: 200px;
}
.text {
  text-align: left;
}
.newsInfo {
  color: #adadad;
  font-size: 13px;
  line-height: 60px;
  border-bottom: 1px solid #f0efef;
  margin-bottom: 20px;
}
.contentbox {
  margin: 20px 0;
  color: #676767;
  font-size: 14px;
}
.titlebox {
  font-size: 30px;
}
.detailurl {
  width: 328px;
  height: 247px;
  margin-right: 20px;
  ::v-deep .goodsimg {
    width: 100%;
    height: 100%;
  }
}
.nextNotesTitle {
    cursor: pointer;
}
.share{
    display: flex;
    align-items: center;
}
.bottombox {
  margin-top: 40px;
  border-top: 1px dashed #f0efef;
  padding-top: 20px;
  justify-content: space-between;
}
.sina_weibo {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -190px
    no-repeat;
}
.qq_share {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -145px
    no-repeat;
}
.Weixin {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -100px
    no-repeat;
}
.baidu_tieba {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -595px
    no-repeat;
}
.douban {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -730px
    no-repeat;
}
.qq_zone {
  background: url("https://2.ss.508sys.com/image/v2/vbg01.png?v=201907171253") -1302px -235px
    no-repeat;
}
.shareIcon {
  display: inline-block;
  height: 33px;
  margin: 0 0 12px 12px;
  width: 33px;
}
</style>